import { useState } from 'react';
import { TextField, Flex, PasswordField } from '@backstage/ui';
import { CustomDialog } from '@internal/backstage-plugin-devops-react';
import { AwsCredential } from '../Providers';

interface GetAwsCredentialDialogProps {
  isOpen: boolean;
  onSubmit: (credential: AwsCredential) => void;
  onClose: () => void;
}

export function GetAwsCredentialDialog(
  props: Readonly<GetAwsCredentialDialogProps>,
) {
  const [accessKey, setAccessKey] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [token, setToken] = useState('');

  const [isAccessKeyValid, setIsAccessKeyValid] = useState(true);
  const [isSecretKeyValid, setIsSecretKeyValid] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(true);

  const validateAccessKey = (key: string): boolean => {
    const accessKeyRegex = /^A[KS]IA[0-9A-Z]{16}$/;
    return accessKeyRegex.test(key);
  };

  const validateSecretKey = (key: string): boolean => {
    const secretKeyRegex = /^[A-Za-z0-9\/+=]{40}$/;
    return secretKeyRegex.test(key);
  };

  const validateToken = (value: string): boolean => {
    const tokenRegex = /^[A-Za-z0-9\/+=]+$/;
    return value.length >= 100 && tokenRegex.test(value);
  };

  const onClose = () => {
    setAccessKey('');
    setSecretKey('');
    setToken('');

    setIsAccessKeyValid(true);
    setIsSecretKeyValid(true);
    setIsTokenValid(true);

    props.onClose();
  };

  const onSubmit = () => {
    if (!validateAccessKey(accessKey)) {
      setIsAccessKeyValid(false);
      return;
    }

    setIsAccessKeyValid(true);

    if (!validateSecretKey(secretKey)) {
      setIsSecretKeyValid(false);
      return;
    }

    setIsSecretKeyValid(true);

    if (token) {
      if (!validateToken(token)) {
        setIsTokenValid(false);
        return;
      }
    }

    setIsTokenValid(true);

    props.onSubmit({
      accessKey: accessKey,
      secretAccessKey: secretKey,
      secretToken: token,
    });
  };

  return (
    <CustomDialog
      isOpen={props.isOpen}
      title="Enter Account Credentials"
      submitButtonText="Run"
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <Flex direction="column" gap="4">
        <TextField
          label="Access Key"
          value={accessKey}
          onChange={value => setAccessKey(value)}
          placeholder="Enter Access Key"
          name="accessKey"
          isRequired
          autoComplete="off"
          type="text"
          isInvalid={!isAccessKeyValid}
        />
        <PasswordField
          label="Secret Key"
          value={secretKey}
          onChange={value => setSecretKey(value)}
          name="secretKey"
          placeholder="Enter Secret Key"
          isRequired
          autoComplete="off"
          inputMode="text"
          isInvalid={!isSecretKeyValid}
        />
        <PasswordField
          label="Token"
          value={token}
          onChange={value => setToken(value)}
          name="token"
          placeholder="Enter Token if exists"
          autoComplete="off"
          inputMode="text"
          isInvalid={!isTokenValid}
        />
      </Flex>
      {/* <TextField
        error={!isAccessKeyValid}
        helperText={isAccessKeyValid ? '' : 'Access Key is incorrect!'}
        required
        margin="dense"
        name="accessKey"
        label="Access Key"
        type="text"
        variant="standard"
        fullWidth
        value={accessKey}
        onChange={event => setAccessKey(event.target.value)}
      />
      <TextField
        error={!isSecretKeyValid}
        helperText={isSecretKeyValid ? '' : 'Secret Key is incorrect!'}
        required
        margin="dense"
        name="secretKey"
        label="Secret Key"
        type="text"
        variant="standard"
        fullWidth
        value={secretKey}
        onChange={event => setSecretKey(event.target.value)}
      />
      <TextField
        error={!isTokenValid}
        helperText={isTokenValid ? '' : 'Token is incorrect!'}
        margin="dense"
        name="token"
        label="Token"
        type="text"
        variant="standard"
        fullWidth
        value={token}
        onChange={event => setToken(event.target.value)}
      /> */}
    </CustomDialog>
  );
}
